<template>
  <div class="box">
    <Echart
      id="centerBottomChart"
      :options="options"
      height="320px"
      width="850px"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      number: 0,
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          tooltip: {
            trigger: "axis",
            formatter: "{b}<br />{c1}",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985"
              }
            }
          },
          color:['red','#409eff'],
          legend: {
            data: ['领用', '归还']
          },
          grid: {
            left: "0",
            right: "15%",
            top: "10%",
            bottom: "24%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: true,
              splitLine: {
                show: true,
                lineStyle: {
                  type: "dashed",
                  color: ["#32495b"]
                }
              },
              axisLabel: {
                interval: 0,
                color: "#9eb5be",
                fontSize: 14
              },
              data: [
                "周四",
                "周五",
                "周六",
                "周日",
                "五月",
                "周一",
                "周二",
                "周三",
              ]
            }
          ],
          yAxis: [
            {
              name: "",
              nameTextStyle: {
                color: "#5182a1",
                fontSize: 14
              },
              type: "value",
              axisLabel: {
                color: "#5182a1",
                fontSize: 14
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#32495b"]
                }
              }
            }
          ],
          series: [
            {
              // For shadow
              type: "bar",
              itemStyle: {
                normal: { color: "rgba(0,0,0,0.05)" }
              },
              barGap: "-100%",
              barCategoryGap: "0",
              data: [
                {
                  name: "周四",
                  value: 3
                },
                {
                  name: "周四",
                  value: 2
                },
                {
                  name: "周四",
                  value: 4
                },
                {
                  name: "周四",
                  value: 2
                },
                {
                  name: "周四",
                  value: 1
                },
                {
                  name: "周四",
                  value: 2
                },
                {
                  name: "周四",
                  value: 4
                },
                {
                  name: "周四",
                  value: 3
                },
              ],
              animation: false
            },
            {
              name: "领用",
              type: "line",
              smooth: true,
              stack: "总量",
              symbolSize: 10,
              showSymbol: true,
              label: {
                normal: {
                  show: true,
                  position: "bottom",
                  color: "#fff",
                  fontSize: 14
                }
              },
              lineStyle: {
                normal: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "red"
                      },
                      {
                        offset: 1,
                        color: "#ffff"
                      }
                    ]
                  },
                  shadowColor: "rgba(0, 0, 0, 0.6)",
                  shadowOffsetY: 4,
                  shadowBlur: 10,
                  width: 4
                }
              },
              // markPoint: {
              //   symbol: "roundRect", // pin
              //   symbolSize: [50, 35],
              //   symbolOffset: [0, "-80%"],
              //   label: {
              //     normal: {
              //       fontSize: 14
              //     }
              //   },
              //   data: [
              //     {
              //       type: "max",
              //       name: "最大值",
              //       label: {
              //         normal: {
              //           color: "#0e1425"
              //         }
              //       },
              //       itemStyle: {
              //         normal: {
              //           color: "#f0dc74"
              //         }
              //       }
              //     },
              //     {
              //       type: "min",
              //       name: "最小值",
              //       itemStyle: {
              //         normal: {
              //           color: "#1265b1"
              //         }
              //       }
              //     }
              //   ]
              // },
              areaStyle: {
                normal: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0.4,
                        color: "#1370c6"
                      },
                      {
                        offset: 1,
                        color: "rgba(19, 112, 198, 0)"
                      }
                    ]
                  }
                }
              },
              data: [3, 2, 5, 3, 2, 1, 4, 5, 3, 5, 3, 2]
            },
            {
              name: "归还",
              type: "line",
              smooth: true,
              stack: "",
              symbolSize: 10,
              showSymbol: true,
              label: {
                normal: {
                  show: true,
                  position: "bottom",
                  color: "#fff",
                  fontSize: 14
                }
              },
              lineStyle: {
                normal: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#409eff"
                      },
                      {
                        offset: 1,
                        color: "#15e198"
                      }
                    ]
                  },
                  shadowColor: "rgba(0, 0, 0, 0.6)",
                  shadowOffsetY: 4,
                  shadowBlur: 10,
                  width: 4
                }
              },
              // markPoint: {
              //   symbol: "roundRect", // pin
              //   symbolSize: [50, 35],
              //   symbolOffset: [0, "-80%"],
              //   label: {
              //     normal: {
              //       fontSize: 14
              //     }
              //   },
              //   data: [
              //     {
              //       type: "max",
              //       name: "最大值",
              //       label: {
              //         normal: {
              //           color: "#0e1425"
              //         }
              //       },
              //       itemStyle: {
              //         normal: {
              //           color: "#f0dc74"
              //         }
              //       }
              //     },
              //     {
              //       type: "min",
              //       name: "最小值",
              //       itemStyle: {
              //         normal: {
              //           color: "#1265b1"
              //         }
              //       }
              //     }
              //   ]
              // },
              areaStyle: {
                normal: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0.4,
                        color: "#1370c6"
                      },
                      {
                        offset: 1,
                        color: "rgba(19, 112, 198, 0)"
                      }
                    ]
                  }
                }
              },
              data: [1, 2, 1, 3, 1, 4, 1, 2, 3, 1, 2, 1]
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {},
  mounted() {}
};
</script>
<style lang="scss" scope>
.box {
  width: 100%;
  height: 100%;
  margin-top: 10px;
  margin-left: 50px;
  .tit {
    float: left;
    margin-top: 18px;
    font-size: 28px;
  }
  .title {
    float: right;
    margin-top: -40px;
    margin-right: 56px;
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/screen/components/centerBottomChart/index.vue